export const QAToolsRoutes = [
  {
    path: "element-inspector",
    name: "elementInspector",
    component: () => import("@/domain/QATools/presentation/pages/ElementInspectorPage.vue"),
    meta: { requiresAuth: true, permissions: "qatools.read" },
  },
  {
    path: "session-viewer",
    name: "sessionViewer",
    component: () => import("@/domain/QATools/presentation/pages/SessionViewerPage.vue"),
    meta: { requiresAuth: true, permissions: "qatools.read" },
  },
  {
    path: "integration-monitor",
    name: "integrationMonitor",
    component: () => import("@/domain/QATools/presentation/pages/IntegrationMonitorPage.vue"),
    meta: { requiresAuth: true, permissions: "qatools.read" },
  },
];
